import React, { Component } from 'react'
import image from '../../mouseimages/battery.jpg'
import '../stylesheets/battery.css'
export default class Battery extends Component {
    render() {
        return (
            <div className="battery-container" data-aos="fade-right">
                <img src={image} alt="battery"></img>
                <section className ="battery-content">
                   <h3> 
                    <p>Blutooth Connectivity</p>
                    <p>with</p>
                    <p>Less power consumption</p>
                    </h3>
                </section>
                
            </div>
        )
    }
}
